(function () {
  "use strict";

  var module = angular.module("uwAgenda.website", [
    "uwAgenda.help",
    "uwAgenda.global",
    "uwAgenda.website.privacypolicy"
  ]);

  module.config(["$stateProvider", WebsiteConfig]);

  function WebsiteConfig($stateProvider) {
    $stateProvider.state("Home.OnlineBookingLinkGenerator", {
      url: "website/:id",
      params: {
        id: { squash: true, value: null }
      },
      templateUrl:
        "/app/website-generator/templates/website-overview.html",
      controller: "WebsiteOverviewController",
      controllerAs: "vm",
      ncyBreadcrumb: {
        label: "{{'link_generator' | translate}}",
      },
    });
  }
})();
